import axios from 'axios';
import AppConfig from '../../AppConfig';
import { axiosBaseConfig, setupInterceptors } from './baseAxiosInstance';

const employeeExperienceAxiosInstance = axios.create({
  ...axiosBaseConfig,
  baseURL: AppConfig.EMPLOYEE_EXPERIENCE_BASE_URL as string,
});

setupInterceptors(employeeExperienceAxiosInstance);

export default employeeExperienceAxiosInstance;
